/**
 * Intelligent back navigation that continues going back until the path actually changes
 * This prevents getting stuck on the same URL when using browser back navigation
 */
export const intelligentBackNavigation = (): void => {
  const maxAttempts = 20; // Prevent infinite loops
  let attempts = 0;

  const goBackAndCheck = () => {
    attempts++;
    const pathBeforeBack = window.location.pathname;
    window.history.back();
    setTimeout(() => {
      const pathAfterBack = window.location.pathname;
      if (pathAfterBack === pathBeforeBack && attempts < maxAttempts) {
        goBackAndCheck();
      }
    }, 10);
  };

  goBackAndCheck();
};
